// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakePayorsModel {
    static getAttributeTypeMap() {
        return SimpleIntakePayorsModel.attributeTypeMap;
    }
}
SimpleIntakePayorsModel.discriminator = undefined;
SimpleIntakePayorsModel.additionalProperties = false;
SimpleIntakePayorsModel.attributeTypeMap = [
    {
        "name": "medical",
        "baseName": "medical",
        "type": "Array<SimpleIntakePayorModel>"
    },
    {
        "name": "pharmacy",
        "baseName": "pharmacy",
        "type": "Array<SimpleIntakePayorModel>"
    },
];
//# sourceMappingURL=simpleIntakePayorsModel.js.map